import { createContext, useReducer } from "react";

export const AdminCategoriesContext = createContext();

export const categoryReducer = (state, action) => {
  switch (action.type) {
    case "SET_CATEGORIES":
      return {
        categories: action.payload,
      };
    case "CREATE_CATEGORY":
      return {
        categories: [action.payload, ...state.categories],
      };
    case "UPDATE_CATEGORY":
      return {
        categories: state.categories.map((c) =>
          c._id === action.payload._id ? action.payload : c
        ),
      };
    case "DELETE_CATEGORY":
      return {
        categories: state.categories.filter(
          (c) => c._id !== action.payload._id
        ),
      };
    default:
      return state;
  }
};

export const AdminCategoriesContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(categoryReducer, {
    categories: null,
  });

  return (
    <AdminCategoriesContext.Provider value={{ ...state, dispatch }}>
      {children}
    </AdminCategoriesContext.Provider>
  );
};
